import { z } from 'zod';
import { arrayToNonEmptyArray } from './array-to-non-empty-array';
import { RetrievalMode } from '@prisma/client';

export const retrievalModeZodEnum = () =>
  z
    .enum(arrayToNonEmptyArray(Object.values(RetrievalMode)))
    .transform(
      (value) =>
        RetrievalMode[value as keyof typeof RetrievalMode] as RetrievalMode,
    );
